import confirmationActionTypes from './confirmation.actionTypes.js';

const initialState = {
  'visible': false,
  'data': {}
};

export default function (state = {}, action) {
  switch (action.type) {
    case confirmationActionTypes.SHOW_CONF_MODAL: {
      return {
        ...state,
        visible: true,
        data: action.data
      };
    }
    case confirmationActionTypes.DISMISS_CONF_MODAL: {
      return {
        ...initialState
      };
    }
    default: {
      return state;
    }
  }
}
